module.exports = __webpack_public_path__ + "img/NAD.4a07fffd.svg";